import { useState } from "react";

import ViewSectionHeader from "./ViewSectionHeader";

const ViewSection = ({ title, actions, content, expandable, isFinalSection = false }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setExpanded(!expanded);
  }

  return (
    <div className={`flex flex-col ${expandable && expanded && 'pb-1'}`}>
      <ViewSectionHeader
        title={title}
        expandable={expandable}
        expanded={expanded}
        onExpandClicked={handleExpandClicked}
        isFinalSection={isFinalSection}
      >
        {actions}
      </ViewSectionHeader>

      {!expandable && content}
      {expandable && expanded && content}
    </div>
  );
}

export default ViewSection;
